import React, { useEffect, useState } from 'react';
import { Button, CardBody, Modal, Row } from 'reactstrap';
import { RootState } from 'index';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { checkInvalidPrimaryKey, dateTimeFormat } from 'GenericForms/Helper';
import BunkeringFileUpload from 'ReportingWizard/EngineerReport/partials/Bunkering/BunkeringFileUpload';
import { GetPageWithID } from '../pendingpage.hook';
import PageNavButton from '../PageNavButton';
import { FileStatus } from 'shared/constants';
import { getCurrentReportAction, getCurrentReportFilesAction, setReportID } from 'Store/Generic/ReportingSlice';
import TableLoading from 'Components/TableLoading';
import { EditReportProvider } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';
import Message from 'Components/Message';

const PendingBDNFiles = () => {
    /** State variables */
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    const [modalState, setModalState] = useState(false);
    const [pageUrl, setPageUrl] = useState("");
    const dispatch = useDispatch();
    /** State variables end */

    useEffect(() => {
        if (!checkInvalidPrimaryKey(VesselID)) {
            return;
        }
        setPageUrl(queryKeyes.pagination.BDNPendingFilesPage.url(VesselID, FileStatus.PENDING));
    }, [VesselID]);

    /**Query for pending BDN files page with status pending */
    const { data: BDNBDNfileUploadingPage, isLoading: isLoadingBDNFileUploadingPage } = useQuery(
        [queryKeyes.pagination.BDNPendingFilesPage.key, pageUrl, VesselID],
        async () => await GetPageWithID(VesselID, pageUrl),
        {
            enabled: true,
            staleTime: Infinity,
        }
    );
    /**End of query  */

    /**
     * Adds a CSS class to the document's body to handle modal styling.
     */
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    /**
     * Toggles the state of the modal and applies the necessary body styling.
     */
    function tog_backdrop() {
        setModalState(!modalState);
        removeBodyCss();
    }

    /**
     * Sets the modal state to open and stores the file name and object for uploading.
     * 
     * @param file - The file object associated with the selected BDN entry.
     */
    const handleUploadButtonClick = (record: any) => {
        dispatch(setReportID(record.vessel_reporting_information_id));
        dispatch(getCurrentReportFilesAction(record.vessel_reporting_information_id, VesselID));
        setModalState(!modalState);
    }

    return (
        <React.Fragment>
            <Row>
                {isLoadingBDNFileUploadingPage && <TableLoading Rows={2} />}
            </Row>
            {!isLoadingBDNFileUploadingPage &&
                <CardBody className="px-0 py-0 pb-0 mt-2">
                    <div className="table-responsive table-height-10">
                        <table className="table mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="p-2 align-middle sr-no-width">#</th>
                                    <th className="p-2 align-middle">Date & time (Local)</th>
                                    <th className="p-2 align-middle">Name of report</th>
                                    <th className="p-2 align-middle">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {BDNBDNfileUploadingPage && BDNBDNfileUploadingPage?.results?.length > 0 ? (
                                    BDNBDNfileUploadingPage?.results?.map((record: any, index: number) => (
                                        <tr key={index}>
                                            <td className="p-2 align-middle text-center">{index + 1}</td>
                                            <td className="p-2 align-middle">{dateTimeFormat(record.reporting_date, false, false, true)}</td>
                                            <td className="p-2 align-middle">{record.name_of_report}</td>
                                            <td className="p-2 align-middle">
                                                <Button
                                                    type="button"
                                                    className='btn-sm'
                                                    color="primary"
                                                    onClick={() => {
                                                        handleUploadButtonClick(record)
                                                        dispatch(getCurrentReportAction(VesselID, record.vessel_reporting_information_id));
                                                    }}>
                                                    Upload
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5} className="p-2 align-middle text-center">
                                            <Message message={'No files are pending for upload.'} type="info" width="100%" />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={5} className="p-2">
                                        <PageNavButton setPageUrl={setPageUrl} pageobj={BDNBDNfileUploadingPage} pageUrl={pageUrl} />
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </CardBody>
            }
            <Modal
                size='xl'
                isOpen={modalState}
                toggle={() => tog_backdrop()}
                backdrop={true}
                id="staticBackdrop"
            >
                <EditReportProvider editReportBool={false} discardwarning={false}>
                    <BunkeringFileUpload
                        setModalState={setModalState}
                        modalState={modalState}
                    />
                </EditReportProvider>
            </Modal>
        </React.Fragment>
    );
};

export default PendingBDNFiles;